import { useContext, useEffect } from 'react';
import { uppy } from 'shared/constants/globals';
import { r } from 'shared/constants/routes';
import { ROUTE } from 'shared/constants/routes_old';
import { UserContext } from 'shared/Providers/User';
import { Members } from 'shared/Pages/members';
import Account from 'shared/Pages/common/Account';
import AudiosList from 'shared/Pages/common/AudiosList/AudiosList';
import { FilePageDeprecated } from 'shared/Pages/common/FilePage';
import Footer from 'shared/Pages/common/Footer/Footer';
import Logout from 'shared/Pages/common/Logout/Logout';
import Project from 'shared/_pages/project';
import ProjectHelpPages from 'shared/Pages/common/Project/helpPage/ProjectHelpPages';
import { ProjectsList } from 'shared/Pages/common/ProjectsList';
import { Roles } from 'shared/Pages/common/Roles';
import { SeriesPage } from 'shared/Pages/common/Series/SeriesDetails';
import SeriesList from 'shared/Pages/common/SeriesList/SeriesList';
import { Stats } from 'shared/Pages/common/Stats';
import EmailCommunications from 'shared/Pages/common/UserManagement/pages/EmailCommunications';
import { UsersPermissions } from 'shared/Pages/common/UsersPermissions';
import VideosList from 'shared/Pages/common/VideosList/VideosList';
import { Switch, Redirect, Route } from 'react-router-dom';
import Experiments from 'shared/Pages/Experiments';
import { Box } from '@mui/material';
import AppBar from 'shared/_components/app-layout/app-bar';
import { APP_BAR_HEIGHT } from 'shared/_components/app-layout/constants';
import Nav from 'shared/_components/app-layout/nav';
import ProjectList from 'shared/_pages/project-list';
import FilePage from 'shared/_pages/video';

const ROUTES: JSX.Element[] = [
	<Route key={r.logout.path} path={r.logout.path} component={Logout} />,
	<Route key={r.account.path} path={r.account.path} component={Account} />,

	<Route key={r.projects.path} path={r.projects.path} component={ProjectList} exact />,
	<Route
		key={r.projects.path + '_v2'}
		path={r.projects.path + '_old'}
		component={ProjectsList}
		exact
	/>,
	<Route key={r.project.path} path={r.project.path} component={Project} />,

	<Route key={r.series.path} path={r.series.path} component={SeriesList} exact />,
	<Route key={ROUTE.series.create()} path={ROUTE.series.create()} component={SeriesList} exact />,
	<Route key={ROUTE.series.id()} path={ROUTE.series.id()} component={SeriesPage} />,

	<Route key={r.videos.path} path={r.videos.path} component={VideosList} exact />,
	// <Route key={r.video.path} path={r.video.path} component={FilePageDeprecated} />,
	<Route key={r.video.path} path={r.video.path} component={FilePage} />,

	<Route key={r.audios.path} path={r.audios.path} component={AudiosList} exact />,
	<Route key={r.audio.path} path={r.audio.path} component={FilePageDeprecated} />,

	<Route key={r.members.path} path={r.members.path} component={Members} />,

	<Route key={r.users.path} path={r.users.path} component={UsersPermissions} />,
	<Route key={r.roles.path} path={r.roles.path} component={Roles} />,
	<Route
		key={r.communications.path}
		path={r.communications.path}
		component={EmailCommunications}
	/>,
	<Route key={r.stats.path} path={r.stats.path} component={Stats} />,

	<Route key={r.experiments.path} path={r.experiments.path} component={Experiments} />,
];

export default function LoggedApp() {
	const {
		permissions: { canUseApp },
	} = useContext(UserContext);

	useEffect(() => {
		uppy.useStatusBar(); // TODO: Remove it from page to ... new Provider ... maybe
	}, []);

	return (
		<Box
			sx={{
				display: 'flex',
				height: '100vh',
				pt: `${APP_BAR_HEIGHT}px`,
			}}
		>
			<AppBar />
			<Nav />
			<Box
				component="main"
				sx={(theme) => ({
					width: '100%',
					// Same paddings as the new app's LayoutMainContent: 1rem, 2rem from `md`
					'--main-gutter': '1rem',
					[theme.breakpoints.up('md')]: { '--main-gutter': '2rem' },
					p: 'var(--main-gutter)',
					overflow: 'auto',
					position: 'relative',
				})}
			>
				{canUseApp ? (
					<>
						<Switch>
							{ROUTES}
							<Redirect to={ROUTE.projects.root} />
						</Switch>
						<Route path={ROUTE.projects.id()} component={ProjectHelpPages} />
					</>
				) : (
					<Switch>
						<Route path={ROUTE.account.root} component={Account} />
						<Redirect to={ROUTE.account.root} />
					</Switch>
				)}
			</Box>
			<Footer />
		</Box>
	);
}
